import {
    createUserWithEmailAndPassword,
    getAuth,
    sendPasswordResetEmail,
    signInWithEmailAndPassword,
    signOut,
} from 'firebase/auth'
import { initializeApp } from 'firebase/app'

const getRequiredEnv = (key) => {
    const value = import.meta.env[key]

    if (!value) {
        throw new Error(`[Firebase] Missing required env: ${key}`)
    }

    return value
}

const firebaseConfig = {
    apiKey: getRequiredEnv('VITE_FIREBASE_API_KEY'),
    authDomain: getRequiredEnv('VITE_FIREBASE_AUTH_DOMAIN'),
    projectId: getRequiredEnv('VITE_FIREBASE_PROJECT_ID'),
    storageBucket: getRequiredEnv('VITE_FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: getRequiredEnv('VITE_FIREBASE_MESSAGING_SENDER_ID'),
    appId: getRequiredEnv('VITE_FIREBASE_APP_ID'),
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
}

export default function () {
    initializeApp(firebaseConfig)

    const resolveAuthResult = async (userCredential) => {
        const firebaseUser = userCredential.user
        const accessToken = await firebaseUser.getIdToken()
        console.log('user accessToken: ', accessToken)
        console.log('firebaseUser: ', firebaseUser)
        return { firebaseUser, accessToken }
    }

    const firebaseLogin = async (email, password) => {
        const userCredential = await signInWithEmailAndPassword(getAuth(), email, password)
        return resolveAuthResult(userCredential)
    }

    const firebaseSignup = async (email, password) => {
        const userCredential = await createUserWithEmailAndPassword(getAuth(), email, password)
        return resolveAuthResult(userCredential)
    }

    const firebaseSendPasswordResetEmail = async (email) => {
        await sendPasswordResetEmail(getAuth(), email)
    }

    return {
        firebaseLogin,
        firebaseSignup,
        firebaseSendPasswordResetEmail,
        getAuth,
        firebaseLogout: signOut,
    }
}
